import projectAkira from "@/assets/project-akira.jpg";
import projectStLeonards from "@/assets/project-stleonards.jpg";
import projectHallidays from "@/assets/project-hallidays.jpg";
import projectCrescent from "@/assets/project-crescent.jpg";
import projectCessnock from "@/assets/project-cessnock.jpg";
import { projectContent, type ProjectContent } from "./projects-content";

export type { ProjectContent };

export interface Project extends ProjectContent {
  image: string;
}

const projectImages: Record<string, string> = {
  "akira": projectAkira,
  "marco": projectStLeonards,
  "hallidays-point": projectHallidays,
  "the-crescent": projectCrescent,
  "cessnock": projectCessnock,
};

export const projects: Project[] = projectContent.map((project) => ({
  ...project,
  image: projectImages[project.slug],
}));
